export default __webpack_public_path__ + "static/media/Chart-7.5d5aa1af.svg";